import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1,
  style: {
    "overflow": "auto",
    "height": "400px"
  }
};
const _hoisted_3 = {
  class: "text-h6 text-gray-500 border-b-2 border-green-regular pb-0.5"
};
const _hoisted_4 = {
  class: "pa-4"
};
const _hoisted_5 = {
  class: "fa fa-cog fa-spin",
  style: {
    "margin-left": "5px"
  }
};
import { onMounted, reactive, computed } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import AccountSetup from './AccountSetup.vue';
import ServiceSetup from './ServiceSetup.vue';
import DateRangeSetup from './DateRangeSetup.vue';
import LeanLawExpenseSetup from './LeanLawExpenseSetup.vue';
import { useCompanyBillingStore } from './companyBillingStore.js';
import { useExpenseSettingStore } from './expenseSettingStore.js';
export default {
  __name: 'Wizard',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    accountingService: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    companyBillingState: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    }
  },
  emits: ['next', 'closeDialog', 'updateCompany'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const expenseWizardState = reactive({
      saving: false,
      loading: false,
      company: {},
      stepTitle: null,
      currentStep: 0,
      step: {
        instructions: 0,
        incomeAccount: 1,
        incomeService: 2,
        sync: 3,
        hardAccount: 4,
        hardService: 5,
        syncDate: 6,
        same: 7,
        softAccount: 8,
        softService: 9
      },
      data: {
        step: 0,
        // stepOffset: 2,

        incomeAccount: {
          account: null,
          create: false,
          name: 'Legal Services'
        },
        incomeService: {
          service: null,
          create: false,
          name: 'Legal Services'
        },
        sync: null,
        syncDate: null,
        onlyBillable: false,
        hardAccount: {
          account: null,
          create: false,
          name: 'Prepaid Expenses'
        },
        hardService: {
          service: null,
          create: false,
          name: 'Prepaid Expenses'
        },
        same: false,
        softAccount: {
          account: null,
          create: false,
          name: 'Billable Expenses'
        },
        softService: {
          service: null,
          create: false,
          name: 'Billable Expense'
        },
        filteredIncome: [],
        filteredHard: [],
        filteredSoft: []
      }
    });
    const emits = __emit;
    const companyBillingStore = useCompanyBillingStore();
    const expenseSettingStore = useExpenseSettingStore();
    companyBillingStore.alerts = props.alerts;
    const enableNextButton = computed(() => {
      return expenseSettingStore.enableNext;
    });
    onMounted(async () => {
      expenseWizardState.loading = true;
      firstStep();
      props.companyBillingState.currentExpenseSettingsTitle = expenseSettingStore.getCurrentTitleFromStep(expenseSettingStore.data.step);
      await expenseSettingStore.loadInitialData(props.userService, props.accountingService);
      expenseWizardState.me = expenseSettingStore.me;
      expenseWizardState.company = expenseSettingStore.company;
      expenseWizardState.services = expenseSettingStore.services;
      expenseWizardState.hardAccounts = expenseSettingStore.hardAccounts;
      expenseWizardState.softAccounts = expenseSettingStore.softAccounts;
      expenseWizardState.incomeAccounts = expenseSettingStore.incomeAccounts;
      expenseWizardState.initialSetup = expenseSettingStore.initialSetup;
      expenseWizardState.data.sync = expenseSettingStore.data.sync;
      expenseWizardState.data.hardAccount.account = expenseSettingStore.data?.hardAccount.account;
      expenseWizardState.data.hardService.service = expenseSettingStore.data?.hardService?.service;
      expenseWizardState.data.incomeService.service = expenseSettingStore.data?.incomeService?.service;
      expenseWizardState.data.incomeAccount.account = expenseSettingStore.data?.incomeAccount?.account;
      expenseWizardState.data.syncDate = expenseSettingStore.data?.syncDate;
      expenseWizardState.data.softService.service = expenseSettingStore.data?.softService?.service;
      expenseWizardState.data.softAccount.account = expenseSettingStore.data?.softAccount?.account;
      expenseWizardState.data.same = expenseSettingStore.data?.hardAccount?.account && expenseSettingStore.data?.hardService?.service && expenseSettingStore.data.hardAccount.account.id === expenseSettingStore.data?.softAccount?.account?.id && expenseSettingStore.data?.hardService?.service?.id === expenseSettingStore.data?.softService?.service?.id;
      expenseWizardState.loading = false;
    });
    const next = () => {
      expenseSettingStore.moveToNextStep();
      emits('next', expenseSettingStore.getCurrentTitleFromStep(expenseSettingStore.data.step), expenseSettingStore.data.step);
    };
    const save = async () => {
      expenseWizardState.saving = true;
      const promises = [];
      try {
        if (expenseWizardState.data.sync) {
          const hardAccountServicePromise = expenseSettingStore.createOrSelectAccountAndService(expenseWizardState.data.hardAccount, expenseWizardState.data.hardService, 'OtherCurrentAsset', 'PrepaidExpenses', props.accountingService, props.alerts);
          promises.push(hardAccountServicePromise);
          if (expenseWizardState.data.same) {
            expenseWizardState.data.softAccount = expenseWizardState.data.hardAccount;
            expenseWizardState.data.softService = expenseWizardState.data.hardService;
          }
        }
        if (!expenseWizardState.data.sync || !expenseWizardState.data.same) {
          const softAccountServicePromise = expenseSettingStore.createOrSelectAccountAndService(expenseWizardState.data.softAccount, expenseWizardState.data.softService, 'Income', 'ServiceFeeIncome', props.accountingService, props.alerts);
          promises.push(softAccountServicePromise);
        }
        if (expenseWizardState.data.incomeService.service || expenseWizardState.data.incomeService.create) {
          const incomeServicePromise = expenseSettingStore.createOrSelectAccountAndService(expenseWizardState.data.incomeAccount, expenseWizardState.data.incomeService, 'Income', 'ServiceFeeIncome', props.accountingService, props.alerts);
          promises.push(incomeServicePromise);
        }
        await Promise.all(promises);
        const expenseSettings = expenseWizardState?.company?.settings?.expenses || {};
        expenseSettings.accountingService = expenseWizardState.data.softService.service;
        expenseSettings.sync = expenseWizardState.data.sync;
        if (expenseSettings.sync) {
          // Only set the property if syncDate is not undefined (omit for "sync all time")
          if (expenseWizardState.data.syncDate !== undefined) {
            expenseSettings.syncDate = expenseWizardState.data.syncDate instanceof Date ? expenseWizardState.data.syncDate.toISOString() : expenseWizardState.data.syncDate;
          }
          expenseSettings.syncAccounts = [{
            account: expenseWizardState.data.hardAccount.account,
            service: expenseWizardState.data.hardService.service
          }];
        }
        const settings = {
          expenses: expenseSettings
        };
        if (expenseWizardState.data.incomeService.service || expenseWizardState.data.incomeService.create) {
          settings.accountingService = expenseWizardState.data.incomeService.service;
        }
        const updatedCompany = await companyBillingStore.updateCompanySettings({
          settings: settings
        });
        emits('updateCompany', updatedCompany);
        expenseSettingStore.data.same = false;
        props.companyBillingState.openWizardDialog = false;
        expenseWizardState.saving = false;
        emits('closeDialog');
      } catch (error) {
        // Surface the error to the user via snackbar
        let userMessage = 'Failed to save QuickBooks settings. ';
        if (error.response?.data?.message) {
          // Extract the QuickBooks error message
          userMessage += error.response.data.message;
        } else if (error.message) {
          userMessage += error.message;
        } else {
          userMessage += 'Please try again or contact support.';
        }
        props.alerts.error(userMessage);
        expenseWizardState.saving = false;
        props.companyBillingState.openWizardDialog = false;
        emits('closeDialog');
      }
    };
    function firstStep() {
      if (props.companyBillingState.params.income) {
        expenseSettingStore.data.step = 0;
      } else {
        expenseSettingStore.data.step = expenseSettingStore.step.sync;
        expenseSettingStore.data.stepOffset = expenseSettingStore.data.step - 1;
      }
    }
    const no = () => {
      expenseWizardState.data.sync = false;
      expenseSettingStore.data.sync = false;
    };
    function cancel() {
      props.companyBillingState.params.income = false;
    }
    return (_ctx, _cache) => {
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_alert = _resolveComponent("v-alert");
      const _component_v_window_item = _resolveComponent("v-window-item");
      const _component_v_container = _resolveComponent("v-container");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_window = _resolveComponent("v-window");
      const _component_v_divider = _resolveComponent("v-divider");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createElementBlock(_Fragment, null, [expenseWizardState.loading && !expenseWizardState.syncing ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_progress_circular, {
        color: "success",
        indeterminate: ""
      })])) : _createCommentVNode("", true), expenseWizardState.syncing ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[9] || (_cache[9] = [_createElementVNode("p", null, "This might take a while if you have lots of expenses", -1), _createElementVNode("p", null, [_createElementVNode("span", null, "Syncing...")], -1)]))])) : (_openBlock(), _createBlock(_component_v_card, {
        key: 2,
        class: "mx-auto wizard-modal pa-0",
        width: "700"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "d-flex justify-space-between align-center pa-2"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_3, _toDisplayString(_unref(expenseSettingStore).stepTitle), 1)]), _createVNode(LlSecondaryButton, {
            icon: "mdi-close",
            variant: "text",
            size: "small",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = $event => emits('closeDialog'))
          })]),
          _: 1
        }), _createVNode(_component_v_window, {
          modelValue: _unref(expenseSettingStore).data.step,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(expenseSettingStore).data.step = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_v_window_item, {
            value: 0,
            class: "window-item"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_v_alert, {
              type: "warning",
              icon: "mdi-alert",
              class: "mb-4"
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createElementVNode("strong", null, "Important:", -1), _createTextVNode(" You might need to involve your accountant. This affects how expenses and services are handled in QuickBooks. ", -1)]))]),
              _: 1
            }), _cache[11] || (_cache[11] = _createElementVNode("div", {
              class: "mb-4"
            }, [_createElementVNode("h4", {
              class: "mb-3"
            }, "QuickBooks Account Setup"), _createElementVNode("p", {
              class: "mb-4"
            }, " Before you can send invoices from LeanLaw to QuickBooks, we need to know which QuickBooks account to use for service and expense income and prepaid expenses. ")], -1)), _cache[12] || (_cache[12] = _createElementVNode("div", {
              class: "mb-4"
            }, [_createElementVNode("h5", {
              class: "mb-3"
            }, "What we'll configure:"), _createElementVNode("ul", {
              class: "list-none pl-0 no-hover"
            }, [_createElementVNode("li", {
              class: "mb-2"
            }, " The QuickBooks account we'll use for services (hours, fixed fees) made in LeanLaw "), _createElementVNode("li", {
              class: "mb-2"
            }, " Sync'ing your expenses from QuickBooks for billing in LeanLaw "), _createElementVNode("li", {
              class: "mb-2"
            }, " The QuickBooks account we'll use for expenses made in LeanLaw ")])], -1))])]),
            _: 1
          }), _createVNode(_component_v_window_item, {
            value: 1,
            class: "window-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_container, {
              fluid: ""
            }, {
              default: _withCtx(() => [_createVNode(AccountSetup, {
                accountingService: __props.accountingService,
                companyBillingState: __props.companyBillingState,
                messageText: `First, which account do you want services (hours, fixed fees) to use in QuickBooks?`,
                alerts: __props.alerts,
                expenseWizardState: expenseWizardState,
                modalValue: expenseWizardState.data.incomeAccount,
                accounts: _unref(expenseSettingStore).incomeAccounts,
                qboType: `Income`,
                qboSubtype: `Service/Fee Income`,
                onUpdateAccount: _ctx.accountChanged
              }, null, 8, ["accountingService", "companyBillingState", "alerts", "expenseWizardState", "modalValue", "accounts", "onUpdateAccount"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_v_window_item, {
            value: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_v_container, {
              fluid: ""
            }, {
              default: _withCtx(() => [_createVNode(ServiceSetup, {
                userService: __props.userService,
                accountingService: __props.accountingService,
                companyBillingState: __props.companyBillingState,
                messageText: `When they're made into invoice line items in QuickBooks, your time and fixed fees will also need a product/service.`,
                alerts: __props.alerts,
                expenseWizardState: expenseWizardState,
                modalValue: expenseWizardState.data.incomeService,
                filteredService: _unref(expenseSettingStore).data.filteredIncome,
                services: expenseWizardState.services,
                onUpdateService: _cache[1] || (_cache[1] = $event => _ctx.serviceChanged($event))
              }, null, 8, ["userService", "accountingService", "companyBillingState", "alerts", "expenseWizardState", "modalValue", "filteredService", "services"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_v_window_item, {
            value: 3,
            class: "window-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_container, {
              fluid: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_v_row, {
                class: "pa-0"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_col, {
                  class: "pa-2 mt-4",
                  cols: "6"
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createElementVNode("p", {
                    class: "text-left"
                  }, "Sync prepaid expenses from QuickBooks?", -1)]))]),
                  _: 1
                }), _createVNode(_component_v_col, {
                  class: "pa-2 flex flex-col",
                  cols: "6"
                }, {
                  default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                    value: "next",
                    class: "p-0 w-full mr-2 mb-2",
                    color: expenseWizardState.data.sync ? 'primary' : undefined,
                    onClick: _cache[2] || (_cache[2] = $event => (expenseWizardState.data.sync = true, _unref(expenseSettingStore).data.sync = true))
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" Enable QuickBooks Sync ", -1)]))]),
                    _: 1
                  }, 8, ["color"]), expenseWizardState.initialSetup ? (_openBlock(), _createBlock(LlSecondaryButton, {
                    key: 0,
                    value: "done",
                    class: "p-0 w-full mb-2",
                    onClick: _cache[3] || (_cache[3] = $event => (expenseWizardState.data.sync = false, _unref(expenseSettingStore).data.sync = false)),
                    color: expenseWizardState.data.sync === false ? 'primary' : undefined
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode(" Maybe Later ", -1)]))]),
                    _: 1
                  }, 8, ["color"])) : _createCommentVNode("", true), !expenseWizardState.initialSetup ? (_openBlock(), _createBlock(LlSecondaryButton, {
                    key: 1,
                    value: "done",
                    class: "p-0 w-full mb-2",
                    color: !expenseWizardState.data.sync ? 'primary' : undefined,
                    onClick: _cache[4] || (_cache[4] = $event => {
                      expenseWizardState.data.sync = false, _unref(expenseSettingStore).data.sync = false;
                      no();
                    })
                  }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" No ", -1)]))]),
                    _: 1
                  }, 8, ["color"])) : _createCommentVNode("", true)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_v_window_item, {
            value: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_v_container, {
              fluid: ""
            }, {
              default: _withCtx(() => [_createVNode(AccountSetup, {
                accountingService: __props.accountingService,
                companyBillingState: __props.companyBillingState,
                messageText: `LeanLaw will sync your QuickBooks expenses from the chosen account (and its subaccounts). We recommend handling expenses created in QuickBooks through an <b>Asset Account</b> normally called Prepaid Expenses or Client Cost Advanced.`,
                alerts: __props.alerts,
                expenseWizardState: expenseWizardState,
                modalValue: expenseWizardState.data.hardAccount,
                accounts: _unref(expenseSettingStore).hardAccounts,
                qboType: `Other Current Assets`,
                qboSubtype: `Prepaid Expenses`
              }, null, 8, ["accountingService", "companyBillingState", "alerts", "expenseWizardState", "modalValue", "accounts"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_v_window_item, {
            value: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_v_container, {
              fluid: ""
            }, {
              default: _withCtx(() => [_createVNode(ServiceSetup, {
                userService: __props.userService,
                accountingService: __props.accountingService,
                companyBillingState: __props.companyBillingState,
                messageText: `Select a Product/Service below. If you sync an expense from QuickBooks and add it to an invoice, the expense line item will use this.`,
                alerts: __props.alerts,
                expenseWizardState: expenseWizardState,
                modalValue: expenseWizardState.data.hardService,
                filteredService: _unref(expenseSettingStore).data.filteredHard,
                services: expenseWizardState.services
              }, null, 8, ["userService", "accountingService", "companyBillingState", "alerts", "expenseWizardState", "modalValue", "filteredService", "services"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_v_window_item, {
            value: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_v_container, {
              fluid: ""
            }, {
              default: _withCtx(() => [_createVNode(DateRangeSetup, {
                userService: __props.userService,
                accountingService: __props.accountingService,
                companyBillingState: __props.companyBillingState,
                alerts: __props.alerts,
                modalValue: expenseWizardState.data.syncDate,
                expenseWizardState: expenseWizardState
              }, null, 8, ["userService", "accountingService", "companyBillingState", "alerts", "modalValue", "expenseWizardState"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_v_window_item, {
            value: 7
          }, {
            default: _withCtx(() => [_createVNode(_component_v_container, {
              fluid: ""
            }, {
              default: _withCtx(() => [_createVNode(LeanLawExpenseSetup, {
                userService: __props.userService,
                accountingService: __props.accountingService,
                companyBillingState: __props.companyBillingState,
                alerts: __props.alerts,
                expenseWizardState: expenseWizardState
              }, null, 8, ["userService", "accountingService", "companyBillingState", "alerts", "expenseWizardState"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_v_window_item, {
            value: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_v_container, {
              fluid: ""
            }, {
              default: _withCtx(() => [_createVNode(AccountSetup, {
                accountingService: __props.accountingService,
                companyBillingState: __props.companyBillingState,
                messageText: `Expenses created in LeanLaw will use this QuickBooks account. We recommend an <b>Income Account</b> for this.`,
                alerts: __props.alerts,
                expenseWizardState: expenseWizardState,
                modalValue: expenseWizardState.data.softAccount,
                accounts: _unref(expenseSettingStore).softAccounts,
                qboType: `Income`,
                qboSubtype: `Service/Fee Income`
              }, null, 8, ["accountingService", "companyBillingState", "alerts", "expenseWizardState", "modalValue", "accounts"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_v_window_item, {
            value: 9
          }, {
            default: _withCtx(() => [_createVNode(_component_v_container, {
              fluid: ""
            }, {
              default: _withCtx(() => [_createVNode(ServiceSetup, {
                userService: __props.userService,
                accountingService: __props.accountingService,
                companyBillingState: __props.companyBillingState,
                messageText: `Expenses created in LeanLaw will use this Product/Service when invoiced.`,
                alerts: __props.alerts,
                expenseWizardState: expenseWizardState,
                modalValue: expenseWizardState.data.softService,
                filteredService: _unref(expenseSettingStore).data.filteredSoft,
                services: expenseWizardState.services
              }, null, 8, ["userService", "accountingService", "companyBillingState", "alerts", "expenseWizardState", "modalValue", "filteredService", "services"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_v_divider), _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [_unref(expenseSettingStore).data.step === 0 && __props.companyBillingState.params.income || _unref(expenseSettingStore).data.step > 0 && _unref(expenseSettingStore).data.step < 9 && !_unref(expenseSettingStore).data.same ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 0,
            value: "next",
            class: "p-0 w-1/2 mr-2",
            color: "primary",
            disabled: !enableNextButton.value || expenseWizardState.loading,
            variant: "elevated",
            onClick: _cache[6] || (_cache[6] = $event => next())
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("Next ", -1)]))]),
            _: 1
          }, 8, ["disabled"])) : _createCommentVNode("", true), _unref(expenseSettingStore).showSave() ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 1,
            value: "next",
            class: "p-0 w-1/2 mr-2",
            color: "primary",
            variant: "elevated",
            disabled: !enableNextButton.value,
            onClick: _cache[7] || (_cache[7] = $event => save())
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("i", _hoisted_5, null, 512), [[_vShow, expenseWizardState.saving]]), _createElementVNode("span", null, _toDisplayString(expenseWizardState.saving ? 'Saving...' : 'Save Changes'), 1)]),
            _: 1
          }, 8, ["disabled"])) : _createCommentVNode("", true), _createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
            class: "p-0 w-2/5",
            onClick: _cache[8] || (_cache[8] = $event => (__props.companyBillingState.openWizardDialog = false, cancel()))
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode(" Cancel ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }))], 64);
    };
  }
};